var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["shipping/pdp-collection-points-info-icon.j2"] = require( "shipping/pdp-collection-points-info-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-store-availability-states.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.contextOrFrameLookup(context, frame, "selectedSku") && runtime.contextOrFrameLookup(context, frame, "bopisCallHasBeenMade") && !runtime.contextOrFrameLookup(context, frame, "noStoreMessage");
frame.set("skuNotAvailableForBopis", t_1, true);
if(frame.topLevel) {
context.setVariable("skuNotAvailableForBopis", t_1);
}
if(frame.topLevel) {
context.addExport("skuNotAvailableForBopis", t_1);
}
var t_2;
t_2 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"disableShipToStore") || (runtime.contextOrFrameLookup(context, frame, "skuNotAvailableForBopis") && !runtime.contextOrFrameLookup(context, frame, "selectedPool"));
frame.set("bopisIsUnavailable", t_2, true);
if(frame.topLevel) {
context.setVariable("bopisIsUnavailable", t_2);
}
if(frame.topLevel) {
context.addExport("bopisIsUnavailable", t_2);
}
var t_3;
t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"bopisEnabled") && !(lineno = 2, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["selectedSku.isDropShip",false]));
frame.set("isBopisEligible", t_3, true);
if(frame.topLevel) {
context.setVariable("isBopisEligible", t_3);
}
if(frame.topLevel) {
context.addExport("isBopisEligible", t_3);
}
if(runtime.contextOrFrameLookup(context, frame, "isBopisEligible")) {
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "defaultStore")) {
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "selectedSku")) {
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"addresses")),"marketing");
frame.set("address", t_4, true);
if(frame.topLevel) {
context.setVariable("address", t_4);
}
if(frame.topLevel) {
context.addExport("address", t_4);
}
var t_5;
t_5 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"name"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"storeName"));
frame.set("name", t_5, true);
if(frame.topLevel) {
context.setVariable("name", t_5);
}
if(frame.topLevel) {
context.addExport("name", t_5);
}
var t_6;
t_6 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"addressLineOne"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"addressLineOne"));
frame.set("addressLineOne", t_6, true);
if(frame.topLevel) {
context.setVariable("addressLineOne", t_6);
}
if(frame.topLevel) {
context.addExport("addressLineOne", t_6);
}
var t_7;
t_7 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"city"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"city"));
frame.set("city", t_7, true);
if(frame.topLevel) {
context.setVariable("city", t_7);
}
if(frame.topLevel) {
context.addExport("city", t_7);
}
var t_8;
t_8 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"state"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"state"));
frame.set("state", t_8, true);
if(frame.topLevel) {
context.setVariable("state", t_8);
}
if(frame.topLevel) {
context.addExport("state", t_8);
}
var t_9;
t_9 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"zip"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"zip"));
frame.set("zip", t_9, true);
if(frame.topLevel) {
context.setVariable("zip", t_9);
}
if(frame.topLevel) {
context.addExport("zip", t_9);
}
output += "<div class=\"u-clearfix\">\n                <div class=\"c-product-bopis__address\">\n\n                    <p class=\"c-product-bopis__p c-product-bopis__p--details-address-name\">\n                        <span> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += " </span>\n                    </p>\n\n                    <p class=\"c-product-bopis__p c-product-bopis__p--details-address\">\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "addressLineOne"), env.opts.autoescape);
output += "<br>\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "city"), env.opts.autoescape);
output += ", ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "state"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "zip"), env.opts.autoescape);
output += "\n                    </p>\n\n                </div>\n\n            </div>\n\n            <div>";
if(runtime.contextOrFrameLookup(context, frame, "selectedPool") && !runtime.contextOrFrameLookup(context, frame, "bopisIsUnavailable")) {
output += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "stock")),"hasEnoughIspuStock")) {
output += "\n\n                        <p class=\"c-product-bopis__p c-product-bopis__p--details-available\">\n\n                            <a href=\"#ispu-info\" class=\"c-product-bopis__details-availability-link\">\n                                ";
output += runtime.suppressValue((lineno = 43, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-available-ispu-sla",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"inStorePickUp")),"inStorePickUpSLA")]})])), env.opts.autoescape);
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "</a>\n\n                        </p>\n\n                    ";
output += "\n                    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "stock")),"hasEnoughStsStock")) {
output += "\n\n                        <p class=\"c-product-bopis__p c-product-bopis__p--details-available\">\n\n                            <a href=\"#ispu-info\" class=\"c-product-bopis__details-availability-link\">\n\n                                ";
output += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedPool")),"stsStockLevel") <= runtime.contextOrFrameLookup(context, frame, "lowStockThreshold")) {
output += "\n\n                                    <span>\n                                        ";
output += runtime.suppressValue((lineno = 62, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-limited"])), env.opts.autoescape);
output += "\n                                    </span>\n\n                                ";
;
}
output += "\n\n                                ";
output += runtime.suppressValue((lineno = 67, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-available-sts-sla",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultStore")),"inStorePickUp")),"shipToStoreSLA")]})])), env.opts.autoescape);
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "</a>\n\n\n                        </p>\n\n                    ";
output += "\n                    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "stock")),"hasEnoughRetailStock")) {
output += "\n\n                        ";
output += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "stock")),"hasLowRetailStock")) {
output += "\n\n                            <p class=\"c-product-bopis__p c-product-bopis__p--details-available\">\n\n                                <a href=\"#ispu-info\" class=\"c-product-bopis__details-availability-link\">\n\n                                    <span>\n                                        ";
output += runtime.suppressValue((lineno = 87, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-limited"])), env.opts.autoescape);
output += "\n                                    </span>\n\n                                    <span>\n                                        ";
output += runtime.suppressValue((lineno = 91, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-call-store"])), env.opts.autoescape);
output += "\n                                    </span>";
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "</a>\n\n                            </p>\n\n                        ";
output += "\n                        ";
})});
}
else {
output += "\n\n                            <p class=\"c-product-bopis__p c-product-bopis__p--details-available\">\n\n                                <a href=\"#ispu-info\" class=\"c-product-bopis__details-availability-link\">\n\n                                    <span>\n                                        ";
output += runtime.suppressValue((lineno = 107, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-in-stock"])), env.opts.autoescape);
output += "\n                                    </span>\n\n                                    ";
output += runtime.suppressValue((lineno = 110, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-retail-stock"])), env.opts.autoescape);
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "</a>\n\n                            </p>\n\n                        ";
})});
}
output += "\n\n                    ";
output += "\n                    ";
;
}
else {
output += "\n\n                        <p class=\"c-product-bopis__p c-product-bopis__p--details-warning\">\n\n                            <a href=\"#ispu-info\" class=\"c-product-bopis__details-availability-link\">\n\n                                ";
output += runtime.suppressValue((lineno = 126, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-out-of-stock"])), env.opts.autoescape);
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
output += "</a>\n\n                        </p>\n\n                    ";
})});
}
;
}
;
}
output += "\n\n                ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "skuNotAvailableForBopis")) {
output += "\n\n                    <p class=\"c-product-bopis__p c-product-bopis__p--details-warning\">\n\n                        <a href=\"#ispu-info\" class=\"c-product-bopis__details-availability-link\">\n\n                            ";
output += runtime.suppressValue((lineno = 141, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-out-of-stock"])), env.opts.autoescape);
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
output += t_31
output += "</a>\n\n                    </p>";
})});
}
;
}
output += "</div>";
var t_34;
t_34 = (lineno = 151, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-check-other-stores"]));
frame.set("changeStoreLabel", t_34, true);
if(frame.topLevel) {
context.setVariable("changeStoreLabel", t_34);
}
if(frame.topLevel) {
context.addExport("changeStoreLabel", t_34);
}
output += "<p class=\"c-product-bopis__p c-product-bopis__p--details-check-stores\">\n\n                <a href=\"#\" ";
output += runtime.suppressValue((lineno = 155, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","store availability",runtime.contextOrFrameLookup(context, frame, "changeStoreLabel")])), env.opts.autoescape);
output += "\n                   class=\"c-product-bopis__details-link js-bopis-change-store\"\n                   data-qa-bopis-change-store >";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "changeStoreLabel"), env.opts.autoescape);
output += "</a>\n\n            </p>\n\n        ";
;
}
else {
output += "\n\n            <p class=\"c-product-bopis__p c-product-bopis__p--select-sku\">\n\n                ";
output += runtime.suppressValue((lineno = 165, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-select-sku"])), env.opts.autoescape);
output += "\n\n            </p>\n\n        ";
;
}
output += "\n\n    ";
;
}
else {
var t_35;
t_35 = (lineno = 173, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-check-nearby-stores"]));
frame.set("changeStoreLabel", t_35, true);
if(frame.topLevel) {
context.setVariable("changeStoreLabel", t_35);
}
if(frame.topLevel) {
context.addExport("changeStoreLabel", t_35);
}
output += "<p class=\"c-product-bopis__p\">\n            ";
output += runtime.suppressValue((lineno = 176, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-no-store"])), env.opts.autoescape);
output += "\n        </p>\n\n        <p class=\"c-product-bopis__p c-product-bopis__p--details-check-stores\">\n\n            <a href=\"#\"\n                ";
output += runtime.suppressValue((lineno = 182, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","store availability",runtime.contextOrFrameLookup(context, frame, "changeStoreLabel")])), env.opts.autoescape);
output += "\n                class=\"c-product-bopis__details-link js-bopis-change-store\"\n                data-qa-bopis-change-store\n            >\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "changeStoreLabel"), env.opts.autoescape);
output += "\n            </a>\n        </p>\n\n    ";
;
}
output += "\n\n";
;
}
else {
output += "\n\n    <p class=\"c-product-bopis__p c-product-bopis__p--details-restricted\">\n\n        <a href=\"#bopis-restricted\" class=\"c-product-bopis__details-availability-link\">\n\n            <span>\n                ";
output += runtime.suppressValue((lineno = 199, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_bopis-restricted"])), env.opts.autoescape);
output += "\n            </span>";
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/product-store-availability-states.j2", null, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
t_36.render(context.getVariables(), frame, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
output += t_37
output += "</a>\n\n    </p>";
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-store-availability-states.j2"] , dependencies)